
import React, {FC} from 'react';
import classNames from 'classnames';
import {ChatPending} from 'components/Assistant/ChatPending';
import {State} from 'components/Assistant/hooks/reducer';
import {Assistant} from 'components/Assistant/hooks/types';
import {ReloadError} from 'components/ReloadError';

import {defaultRenderer, Renderer} from './renderer';

import * as styles from './styles.module.scss';

const isLast = (state: State, index: number): boolean => (
	!state.pending && index === state.messages.length - 1
);

type ChatAreaProps = Omit<Assistant, 'send'> & {
	className?: string
	pending?: {
		className?: string
		variant?: 'green' | 'white'
	}
	prompt?: string
	send?: Assistant['send']
	track?: string
	renderer?: Renderer
};

export const ChatArea: FC<ChatAreaProps> = ({
	prompt,
	className,
	pending,
	state,
	renderer = defaultRenderer,
	children,
	...rest
}) => (
	<div className={classNames(styles.area, className)}>
		{prompt && renderer({
			message: {
				id: 'prompt',
				source: 'ASSISTANT',
				message: prompt,
				created: {unix: 0},
			},
			index: -1,
			isLast: false,
			...rest,
		})}

		{/* Show all messages from API */}
		{state.messages.map((m, i) => (
			renderer({
				message: m,
				index: i,
				isLast: isLast(state, i),
				...rest,
			})
		))}

		{/* We show ChatHints if no messages */}
		{state.messages.length === 0 && children}

		{/* Show pending, scroll if prompt (otherwise, may be initial load) */}
		{state.pending && (
			<ChatPending
				className={pending?.className}
				scroll={Boolean(prompt) || state.messages.length > 1}
				variant={pending?.variant}
			/>
		)}

		{/* Display error state here */}
		{state.error && <ReloadError />}
	</div>
);
